import type { MaasModelSourceModelPlaza } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';
import type { ArtifactItem } from '@/pages/data-center/artifact-center/shared';

/** 从模型广场制品解析 modelplaza 来源（与模型仓库部署跳转参数一致） */
export function getModelPlazaSourceFromArtifact(item: ArtifactItem): MaasModelSourceModelPlaza {
  const model = String(item.gitSourceUrl || item.options?.modelRepo?.modelName || item.name || '').trim();
  const url = String(item.gitRefUrl || '').trim();
  return { model, url };
}

/** 制品模型大小：字符串，自带单位 */
export function getModelPlazaArtifactSize(item: ArtifactItem): string {
  return item.gitSourceSize || '';
}

/** 当前表单 modelplaza 是否与制品匹配 */
export function isModelPlazaSourceMatch(item: ArtifactItem, source?: Partial<MaasModelSourceModelPlaza>): boolean {
  const model = String(source?.model || '').trim();
  const url = String(source?.url || '').trim();
  if (!model || !url) return false;
  const expected = getModelPlazaSourceFromArtifact(item);
  return expected.model === model && expected.url === url;
}
